(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olayz-editorial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-oe-choose]');
  if (!link || new URL(link.href).pathname !== location.pathname) return;
  const picker = document.querySelector('variant-picker');
  if (!picker) return;
  event.preventDefault();
  picker.scrollIntoView({behavior:'instant',block:'center'});
  const control = picker.querySelector('input:not([disabled]), select, button:not([disabled])');
  control?.focus({preventScroll:true});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olayz-exact"] && !Shopify.designMode) return;
  try {
    
function olayzStartBanners() {
  document.querySelectorAll('.oy-banner-video').forEach(video => {
    video.muted = true;
    video.defaultMuted = true;
    video.controls = false;
    video.removeAttribute('controls');
    const attempt = video.play();
    if (attempt) attempt.catch(() => {});
  });
}
olayzStartBanners();
document.addEventListener('shopify:section:load', olayzStartBanners);
document.addEventListener('touchstart', olayzStartBanners, { once: true, passive: true });

  } catch(e) { console.error(e); }
})();
})();
